<template>
  <div id="auth">
    <div v-if="loading" id="preloader">
      <div class="spinner"></div>
    </div>
    <div v-else>
      <transition appear name="slide-fade">
        <div>
          <!-- Page Content -->
          <div class="page-content">
            <!-- Banner -->
            <div class="banner-wrapper shape-1">
              <div class="container inner-wrapper">
                <img src="assets/images/logo/logo-xs.png" class="mx-auto" />
                <h2 class="dz-title mt-4">Visitaste a {{ nombre_aliado }}!</h2>
                <p class="mb-0">
                  ¿Cómo te fue en tu visita? Cuéntanos y acumula puntos en
                  Reddy.
                </p>
              </div>
            </div>
            <!-- Banner End -->
            <div class="container company-detail mt-4">
              <div class="account-area">
                <div class="text-center" style="height: auto">
                  <transition appear name="slide-fade">
                    <div class="mt-4 pt-4">
                       <h5 class="fw-bold">
                        ¿Qué usaste?
                      </h5>
                      <div class="text-center mt-3">
                        <div class="form-group">
                          <select v-model="id_servicio_alianza"  class="form-control">
                            <option>Selecciona un servicio</option>
                            <option v-for="(servicio, index_servicio) in  aliado.alianza.servicios" v-bind:key="index_servicio" v-bind:value="servicio.id_servicio_alianza">{{servicio.servicio}}</option>
                          </select>
                        </div>
                      </div>
                        <hr />
                      <h5 class="fw-bold">
                        Aseo y limpieza de las instalaciones
                      </h5>
                      <div class="text-center mt-3">
                        <a
                          v-on:click="valor_aseo = 1"
                          v-bind:class="{
                            'rating-select': valor_aseo == 1,
                            rating: valor_aseo != 1,
                          }"
                          href="javascript:void(0)"
                        >
                          😠
                        </a>
                        <a
                          v-on:click="valor_aseo = 2"
                          v-bind:class="{
                            'rating-select': valor_aseo == 2,
                            rating: valor_aseo != 2,
                          }"
                          href="javascript:void(0)"
                        >
                          😞
                        </a>
                        <a
                          v-on:click="valor_aseo = 3"
                          v-bind:class="{
                            'rating-select': valor_aseo == 3,
                            rating: valor_aseo != 3,
                          }"
                          href="javascript:void(0)"
                        >
                          😑
                        </a>
                        <a
                          v-on:click="valor_aseo = 4"
                          v-bind:class="{
                            'rating-select': valor_aseo == 4,
                            rating: valor_aseo != 4,
                          }"
                          href="javascript:void(0)"
                        >
                          😃
                        </a>
                        <a
                          v-on:click="valor_aseo = 5"
                          v-bind:class="{
                            'rating-select': valor_aseo == 5,
                            rating: valor_aseo != 5,
                          }"
                          href="javascript:void(0)"
                        >
                          🤩
                        </a>
                      </div>
                      <hr />
                      <h5 class="fw-bold">
                        ¿Cómo fue el servicio de {{ nombre_aliado }}?
                      </h5>
                      <div class="text-center mt-3">
                        <a
                          v-on:click="valor_servicio = 1"
                          v-bind:class="{
                            'rating-select': valor_servicio == 1,
                            rating: valor_servicio != 1,
                          }"
                          href="javascript:void(0)"
                        >
                          😠
                        </a>
                        <a
                          v-on:click="valor_servicio = 2"
                          v-bind:class="{
                            'rating-select': valor_servicio == 2,
                            rating: valor_servicio != 2,
                          }"
                          href="javascript:void(0)"
                        >
                          😞
                        </a>
                        <a
                          v-on:click="valor_servicio = 3"
                          v-bind:class="{
                            'rating-select': valor_servicio == 3,
                            rating: valor_servicio != 3,
                          }"
                          href="javascript:void(0)"
                        >
                          😑
                        </a>
                        <a
                          v-on:click="valor_servicio = 4"
                          v-bind:class="{
                            'rating-select': valor_servicio == 4,
                            rating: valor_servicio != 4,
                          }"
                          href="javascript:void(0)"
                        >
                          😃
                        </a>
                        <a
                          v-on:click="valor_servicio = 5"
                          v-bind:class="{
                            'rating-select': valor_servicio == 5,
                            rating: valor_servicio != 5,
                          }"
                          href="javascript:void(0)"
                        >
                          🤩
                        </a>
                      </div>
                      <hr />
                      <h5 class="fw-bold">
                        ¿Cómo evalúas la calidad de los servicios o productos en
                        {{ nombre_aliado }}?
                      </h5>
                      <div class="text-center mt-3">
                        <a
                          v-on:click="valor_calidad = 1"
                          v-bind:class="{
                            'rating-select': valor_calidad == 1,
                            rating: valor_calidad != 1,
                          }"
                          href="javascript:void(0)"
                        >
                          😠
                        </a>
                        <a
                          v-on:click="valor_calidad = 2"
                          v-bind:class="{
                            'rating-select': valor_calidad == 2,
                            rating: valor_calidad != 2,
                          }"
                          href="javascript:void(0)"
                        >
                          😞
                        </a>
                        <a
                          v-on:click="valor_calidad = 3"
                          v-bind:class="{
                            'rating-select': valor_calidad == 3,
                            rating: valor_calidad != 3,
                          }"
                          href="javascript:void(0)"
                        >
                          😑
                        </a>
                        <a
                          v-on:click="valor_calidad = 4"
                          v-bind:class="{
                            'rating-select': valor_calidad == 4,
                            rating: valor_calidad != 4,
                          }"
                          href="javascript:void(0)"
                        >
                          😃
                        </a>
                        <a
                          v-on:click="valor_calidad = 5"
                          v-bind:class="{
                            'rating-select': valor_calidad == 5,
                            rating: valor_calidad != 5,
                          }"
                          href="javascript:void(0)"
                        >
                          🤩
                        </a>
                      </div>
                      <hr />
                      <h5 class="fw-bold">Cuéntamos un poco más...</h5>
                      <small>(Opcional)</small>
                      <textarea
                        v-model="comentarios"
                        class="form-control my-textarea mt-2"
                        rows="5"
                      />
                      <div class="container d-grid gap-2">
                        <button
                          data-bs-toggle="modal"
                          data-bs-target="#modal"
                          v-on:click="set_calificacion"
                          :disabled="
                            valor_aseo == null ||
                            valor_calidad == null ||
                            valor_servicio == null
                          "
                          class="btn btn-primary btn-rounded"
                        >
                          Enviar
                        </button>
                      </div>
                      <div class="container d-grid gap-2">
                        <button
                          v-on:click="set_pendiente"
                          class="btn btn-primary btn-rounded"
                        >
                          Guardar
                        </button>
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <!-- Page Content End -->
        </div>
      </transition>
    </div>
    <div id="modal" class="modal fade" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body modal_puntos text-center">
            <transition v-if="success" appear name="slide-fade">
              <div>
                <img
                  src="assets/images/check.png"
                  style="max-width: 100px"
                /><br />
                <span class="fw-bold" style="font-size: 1.5em"> ¡Súper! </span
                ><br />
                <span class="fw-bold" style="font-size: 1.5em">
                  Acumulaste 10 Reddy Puntos
                </span>
                <br />
                <button
                  v-on:click="fin"
                  data-bs-dismiss="modal"
                  class="btn btn-orange rounded-pill mt-3"
                >
                  Ok
                </button>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Feedback",
  metaInfo: {
    title: "Registra tu visita - Reddy App",
  },
  data() {
    return {
      loading: true,
      token: null,
      nombre_aliado: null,
      step: 1,
      id_servicio_alianza:null,
      valor_aseo: null,
      valor_servicio: null,
      valor_calidad: null,
      comentarios: null,
      success: false,
      aliado:null,
      id_val:null,
    };
  },
  created: function () {
    var session = localStorage.getItem("sess_reddy_app");
    if (session == undefined) {
      this.$router.push("/auth");
    } else {
      session = JSON.parse(session);
      this.session = session;
      this.usuario = session.usuario;
    }

    var aliado_qr = localStorage.getItem("aliado_qr");
    if (aliado_qr == undefined) {
      if (this.$route.params.id == undefined) {
        this.$router.push("/");
      }else{
        this.id_val = this.$route.params.id ;
        this.get_penVal();
      }
      
    } else {
      aliado_qr = JSON.parse(aliado_qr);
      this.token = aliado_qr.token;
      this.id_aliado = aliado_qr.id_aliado;
      this.nombre_aliado = aliado_qr.aliado;
      this.get_servicios(this.id_aliado);
    }
    
  },
  methods: {
    next: function () {
      this.step++;
    },
    get_penVal: function(){
      this.loading = true;

      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      axios
        .get(this.$base_url + "membresias/get_calificacion/" + this.id_val, {
          headers: headers,
        })
        .then((response) => {
          console.log(response.data.data.id_aliado);
          this.loading = false;
          this.id_aliado = response.data.data.id_aliado;
          this.comentarios = response.data.data.comentarios;
          this.valor_aseo = response.data.data.aseo;
          this.valor_servicio = response.data.data.servicio;
          this.valor_calidad = response.data.data.calidad;
          this.id_servicio_alianza = response.data.data.id_servicio;
          this.get_servicios(this.id_aliado);
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    set_calificacion: function () {
      this.loading = true;

      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      

      if(this.id_val){
        let params = {
          id_valoracion: this.id_val,
          id_servicio_alianza: this.id_servicio_alianza,
          id_aliado: this.id_aliado,
          valor_aseo: this.valor_aseo,
          valor_servicio: this.valor_servicio,
          valor_calidad: this.valor_calidad,
          comentarios: this.comentarios,
          complete: 1
        };
        axios
        .post(this.$base_url + "membresias/set_calificacion3", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.success = true;
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
      }else{
        let params = {
          id_servicio_alianza: this.id_servicio_alianza,
          id_aliado: this.id_aliado,
          valor_aseo: this.valor_aseo,
          valor_servicio: this.valor_servicio,
          valor_calidad: this.valor_calidad,
          comentarios: this.comentarios,
          complete: 1
        };
        axios
        .post(this.$base_url + "membresias/set_calificacion2", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.success = true;
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
      }

      
    },
    set_pendiente: function () {
      this.loading = true;

      const vm = this;
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      

      if(this.id_val){
        let params = {
          id_valoracion: this.id_val,
          id_servicio_alianza: this.id_servicio_alianza,
          id_aliado: this.id_aliado,
          valor_aseo: this.valor_aseo,
          valor_servicio: this.valor_servicio,
          valor_calidad: this.valor_calidad,
          comentarios: this.comentarios,
          complete: 0
        };
        axios
        .post(this.$base_url + "membresias/set_pendiente2", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.success = true;
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
        this.$router.push("/");
      }else{
        let params = {
          id_servicio_alianza: this.id_servicio_alianza,
          id_aliado: this.id_aliado,
          valor_aseo: this.valor_aseo,
          valor_servicio: this.valor_servicio,
          valor_calidad: this.valor_calidad,
          comentarios: this.comentarios,
          complete: 0
        };
        axios
        .post(this.$base_url + "membresias/set_pendiente", params, {
          headers: headers,
        })
        .then((response) => {
          if (!response.data.status) {
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: response.data.message,
            });
          } else {
            vm.success = true;
            vm.loading = false;
          }
        })
        .catch(
          (error) =>
            vm.$notify({
              type: "error",
              group: "foo",
              title: "<i class='fa fa-exclamation-circle'></i> Ups!",
              text: error,
            }),
          (vm.loading = false)
        )
        .finally();
        this.$router.push("/");
      }
    },
    get_servicios:function(id_aliado){
      const headers = {
        "Content-Type": "application/json",
        "x-api-key": this.$api_key,
        token: this.session.token,
      };
      let config = {
        headers: headers,
        params: {
          favorito: 1,
          comentarios: 1,
        },
      };
      const vm = this;
      axios
        .get(this.$base_url + "aliados/aliado/" + id_aliado, config, {
          headers: headers,
        })
        .then((response) => {
          console.log(response.data.data);
          this.aliado = response.data.data;
          this.loading = false;
          this.nombre_aliado = this.aliado.nombre_aliado;
        })
        .catch((error) =>
          vm.$notify({
            type: "error",
            group: "foo",
            title: "<i class='fa fa-exclamation-circle'></i> Ups!",
            text: error,
          })
        )
        .finally();
    },
    fin: function () {
      this.$router.push("/");
    },
  },
  mounted: function () {
  },
};
</script>
<style scoped>
/* local styles */
.swal2-styled.swal2-confirm {
  background-color: #e1652c;
}
</style>